import React from 'react';
import { Search, Filter as FilterIcon, Plus, SlidersHorizontal } from 'lucide-react';
import { Button } from './Button';
import { Filter } from './Filter';

interface ActionToolbarProps {
  searchPlaceholder?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  filterOptions?: any[];
  onFilterChange?: (key: string, value: any) => void;
  actions?: React.ReactNode;
  onPrimaryAction?: () => void;
  primaryActionLabel?: string;
  primaryActionIcon?: string | React.ReactNode;
  primaryActionDisabled?: boolean;
  hidePrimaryAction?: boolean;
  isLoading?: boolean;
}

export const ActionToolbar = ({
  searchPlaceholder = 'Tìm kiếm...',
  searchValue,
  onSearchChange,
  filterOptions,
  onFilterChange,
  actions,
  onPrimaryAction,
  primaryActionLabel,
  primaryActionIcon = <Plus className="w-4 h-4" />,
  primaryActionDisabled,
  hidePrimaryAction,
  isLoading,
}: ActionToolbarProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 w-full justify-between items-stretch md:items-center bg-white/70 backdrop-blur-xl p-2.5 rounded-[32px] border border-white/20 shadow-sm">
      <div className="flex flex-wrap gap-3 flex-1">
        {/* Search Input Group */}
        <div className="relative flex-1 min-w-[240px] md:max-w-sm group">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 group-focus-within:text-blue-500 transition-colors" />
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full h-12 pl-12 pr-4 rounded-3xl border-none bg-slate-50/50 focus:bg-white focus:ring-4 focus:ring-blue-500/10 transition-all font-medium text-sm text-slate-900 placeholder:text-slate-400 placeholder:font-medium"
          />
        </div>

        {/* Filter Group */}
        {filterOptions && onFilterChange && (
          <div className="flex items-center gap-2">
            <Filter
              options={filterOptions}
              onFilterChange={onFilterChange}
            />
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        {actions}

        {onPrimaryAction && primaryActionLabel && !hidePrimaryAction && (
          <Button
            variant="primary"
            onClick={onPrimaryAction}
            className="h-12 px-6 rounded-3xl gap-2 font-black text-xs  tracking-widest shadow-xl shadow-blue-500/20 active:scale-95 transition-all"
            disabled={isLoading || primaryActionDisabled}
            icon={primaryActionIcon}
          >
            {primaryActionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
